import gamevideojs from "./gamevideojs";
import Url from "domurl";
import "videojs-thumbnail-sprite";

export default class ClubAdminObservationPlayer {
  constructor(options = {}) {

    // Player
    this.player = null;
    this.editTime = false;


    this.options = Object.assign(
      {
        //customize and force custom options
      },
      options
    );

    // Times
    this.currentTime = 0;
    this.currentStartTime = 0;
    this.currentEndTime = 0;
    this.incrementDecrement = 1;
    this.incrementDecrementMinusPlus = 15;

    // Define elements
    this.defineElements();

    // Initialize a new gamevideojs
    if ($("#club-admin-observation-player").length > 0) {
      this.player = gamevideojs("#club-admin-observation-player", this.options);

      // Added video sprites/frames images
      let frames = $("#club-admin-observation-player").data("frames");
      let sprites = []
      let frameStart = 0;

      frames.forEach(frame => {
        sprites.push({
          url: frame,
          start: frameStart,
          duration: 320,
          width: 160,
          height: 90,
          interval: 2,
        });
  
        frameStart = frameStart + 320;
      });

      this.player.thumbnailSprite({
        sprites: sprites
      });

      // Enforce force mute for club users
      this.enforceForceMute();

      // Update player time
      this.player.on("timeupdate", () => {
        this.updateTimes();
      });
    }
  }

  defineElements() {
    // Spans 
    this.observationEventTime = $(".club-admin-observation-event-time");
    this.observationEventStartTime = $(".club-admin-observation-event-start-time");
    this.observationEventEndTime = $(".club-admin-observation-event-end-time");
    this.observationEventEndTimeFix = $(".club-admin-observation-event-end-time-fix");

    // Fields
    this.observationEventTimeField = $(".club-admin-observation_event_time");
    this.observationEventStartTimeField = $(".club-admin-observation_event_start_time");
    this.observationEventEndTimeField = $(".club-admin-observation_event_end_time");

    // Edit times
    this.observationEditEventTimeField = $(".club-admin-observation_edit_event_time");
    this.observationEditEventStartTimeField = $(
      ".club-admin-observation_edit_event_start_time"
    );
    this.observationEditEventEndTimeField = $(
      ".club-admin-observation_edit_event_end_time"
    );

    // Actions buttons minus and plus
    this.btnMinusEventTime = $(".btn-minus-event-time");
    this.btnPlusEventTime = $(".btn-plus-event-time");
    this.btnMinusEventStartTime = $(".btn-minus-event-start-time");
    this.btnPlusEventStartTime = $(".btn-plus-event-start-time");
    this.btnMinusEventEndTime = $(".btn-minus-event-end-time");
    this.btnPlusEventEndTime = $(".btn-plus-event-end-time");
    this.btnCancelKmi = $(".btn-cancel-kmi");

    // Camera angle links
    this.cameraAngleLinks = $(".camera-angle-link");

    // Cancel btns
    this.btnCancelCompetency = $("#btn-cancel-competency");
    this.btnCancelKeyIncident = $("#btn-cancel-kmi");
    this.btnCancelKeyIncidentCaution = $("#btn-cancel-kmi-caution");

    // Add behaviours
    this.btnBehaviours();
  }

  btnBehaviours() {
    let scope = this;

    this.btnMinusEventTime.on("click", function (event) {
      scope.clickBtnTimer(this, event);
    });

    this.btnPlusEventTime.on("click", function (event) {
      scope.clickBtnTimer(this, event);
    });

    this.btnMinusEventStartTime.on("click", function (event) {
      scope.clickBtnTimer(this, event);
    });

    this.btnPlusEventStartTime.on("click", function (event) {
      scope.clickBtnTimer(this, event);
    });

    this.btnMinusEventEndTime.on("click", function (event) {
      scope.clickBtnTimer(this, event);
    });

    this.btnPlusEventEndTime.on("click", function (event) {
      scope.clickBtnTimer(this, event);
    });

    this.btnCancelCompetency.on("click", function (event) {
      event.preventDefault();
      $("#flush-headingOne").find("button").click();
    });

    this.btnCancelKeyIncident.on("click", function (event) {
      event.preventDefault();
      $("#flush-headingFour").find("button").click();
    });

    this.btnCancelKeyIncidentCaution.on("click", function (event) {
      event.preventDefault();
      $("#flush-headingFive").find("button").click();
    });
  }

  clickBtnTimer(element, event) {
    event.preventDefault();
    this.editTime = true;

    this.pausePlayer();

    let action = $(element).data("action");
    let updateField = $($(element).data("update-field"));
    let updateView = $($(element).data("update-view"));
    let type = $(element).data("type");

    if (action == "minus") {
      this.decrementTimer(type, updateField, updateView);
    } else {
      this.incrementTimer(type, updateField, updateView);
    }
  }

  pausePlayer() {
    if (this.player) {
      this.player.pause();
    }
  }

  dispose() {
    if (this.player != null) {
      this.player.dispose();
    }
  }

  incrementTimer(type, updateField, updateView) {
    this.incrementOrDecrementTimer("plus", type, updateField, updateView);
  }

  decrementTimer(type, updateField, updateView) {
    this.incrementOrDecrementTimer("minus", type, updateField, updateView);
  }

  incrementOrDecrementTimer(action, type, updateField, updateView) {
    let currentVal = parseFloat(this.convertDecimalMinutesToSeconds(updateField.val()));
    let newValue = currentVal;
    let increment_action =
      type == "time"
        ? this.incrementDecrement
        : this.incrementDecrementMinusPlus;

    if (action == "minus") {
      newValue = currentVal - increment_action;
    } else {
      newValue = currentVal + increment_action;
    }

    if (newValue < 0) {
      newValue = 0;
    }

    if (type == "time") {
      this.currentTime = newValue;

      // Start time
      if (this.currentStartTime >= this.currentTime) {
        this.currentStartTime =
          this.currentTime - this.incrementDecrementMinusPlus;

        this.updateTimerWithValue(
          this.currentStartTime,
          this.observationEventStartTimeField,
          this.observationEventStartTime
        );
      }

      // End time
      if (this.currentEndTime <= this.currentTime) {
        this.currentEndTime =
          this.currentTime + this.incrementDecrementMinusPlus;

        this.updateTimerWithValue(
          this.currentEndTime,
          this.observationEventEndTimeField,
          this.observationEventEndTime
        );
      }
    } else if (type == "start") {
      this.currentStartTime = newValue;

      // Current time
      if (this.currentStartTime >= this.currentTime) {
        this.currentTime =
          this.currentStartTime + this.incrementDecrementMinusPlus;
        this.updateTimerWithValue(
          this.currentTime,
          this.observationEventTimeField,
          this.observationEventTime
        );
      }

      // End time
      if (this.currentEndTime <= this.currentStartTime) {
        this.currentEndTime =
          this.currentTime + this.incrementDecrementMinusPlus;

        this.updateTimerWithValue(
          this.currentEndTime,
          this.observationEventEndTimeField,
          this.observationEventEndTime
        );
      }

      // End time
      if (this.currentTime == this.currentEndTime) {
        this.currentEndTime =
          this.currentTime + this.incrementDecrementMinusPlus;

        this.updateTimerWithValue(
          this.currentEndTime,
          this.observationEventEndTimeField,
          this.observationEventEndTime
        );
      }
    } else if (type == "end") {
      this.currentEndTime = newValue;

      // Current time
      if (this.currentEndTime == this.currentTime) {
        this.currentTime =
          this.currentEndTime - this.incrementDecrementMinusPlus;

        this.updateTimerWithValue(
          this.currentTime,
          this.observationEventTimeField,
          this.observationEventTime
        );
      }

      // Start time
      if (this.currentStartTime >= this.currentTime) {
        this.currentStartTime =
          this.currentTime - this.incrementDecrementMinusPlus;

        this.updateTimerWithValue(
          this.currentStartTime,
          this.observationEventStartTimeField,
          this.observationEventStartTime
        );
      }
    }

    if (this.currentTime < 0) {
      this.currentTime = 0;
    }

    if (this.currentStartTime < 0) {
      this.currentStartTime = 0;
    }

    if (this.currentEndTime < 0) {
      this.currentEndTime = 0;
    }

    if (newValue < 0) {
      newValue = 0;
    }

    this.player.currentTime(this.currentTime);
    this.updateTimerWithValue(newValue, updateField, updateView);

    //this.updateVideoCrop();
  }

  convertSecondsToDecimalMinutes(seconds) {
    return (seconds / 60).toFixed(5);
  }

  convertDecimalMinutesToSeconds(decimalMinutes) {
    return (decimalMinutes * 60).toFixed(0);
  }

  updateTimerWithValue(newValue, updateField, updateView) {
    let minutesAndSeconds = this.calcMinutesAndSeconds(newValue);
    // let formatedMinutesAndSeconds = this.formatHourMinute(
    //   minutesAndSeconds[0],
    //   minutesAndSeconds[1]
    // );

    updateField.val( this.convertSecondsToDecimalMinutes( newValue ) );
    updateView.html(
      this.player.gamevideojs.returnFormattedDataMatch(
        newValue
        //this.player.gamevideojs.getMatchTimeByRealTime(newValue)
      )
    );
  }

  enforceForceMute() {
    const playerElement = document.getElementById('club-admin-observation-player');
    if (!playerElement) return;

    const forceMute = playerElement.getAttribute('data-force-mute') === 'true';

    if (forceMute && this.player) {
      // Force mute and set volume to 0
      this.player.muted(true);
      this.player.volume(0);

      // Hide volume controls
      const volumePanel = this.player.controlBar.volumePanel;
      if (volumePanel) {
        volumePanel.hide();
      }

      // Prevent unmuting via events
      this.player.on('volumechange', () => {
        if (!this.player.muted() || this.player.volume() > 0) {
          this.player.muted(true);
          this.player.volume(0);
        }
      });

      // Add CSS class to hide controls
      playerElement.classList.add('force-muted-player');

      console.log('[Club User] Audio disabled - volume controls removed');
    }
  }

  updateTimes() {
    this.currentTime = this.player.currentTime();
    //this.currentTime = this.player.gamevideojs.getCurrentRealTime();

    if (!this.editTime) {
      this.currentStartTime =
        this.currentTime - this.incrementDecrementMinusPlus;
      this.currentEndTime = this.currentTime + this.incrementDecrementMinusPlus;
    }

    if (this.currentStartTime < 0) {
      this.currentStartTime = 0;
    }

    // Update divs
    this.observationEventTime.html(
      this.player.gamevideojs.returnFormattedDataMatch(
        this.currentTime
        //this.player.gamevideojs.getMatchTimeByRealTime(this.currentTime)
      )
    );
    this.observationEventStartTime.html(
      this.player.gamevideojs.returnFormattedDataMatch(
        this.currentStartTime
        //this.player.gamevideojs.getMatchTimeByRealTime(this.currentStartTime)
      )
    );
    this.observationEventEndTime.html(
      this.player.gamevideojs.returnFormattedDataMatch(
        this.currentEndTime
        //this.player.gamevideojs.getMatchTimeByRealTime(this.currentEndTime)
      )
    );
    
    if( this.observationEventEndTimeFix.length > 0 ){
      this.observationEventEndTimeFix.html(
        this.player.gamevideojs.selectorElement.querySelector('.gamevideojs-control-display-time-total').innerHTML
      );
    } 

    // Update fields values
    this.observationEventTimeField.val( this.convertSecondsToDecimalMinutes( this.currentTime ) );
    this.observationEventStartTimeField.val( this.convertSecondsToDecimalMinutes( this.currentStartTime ) );
    this.observationEventEndTimeField.val( this.convertSecondsToDecimalMinutes( this.currentEndTime ) );

    // Update edit fields values
    this.observationEditEventTimeField.val(
      this.player.gamevideojs.returnFormattedDataMatch(this.currentTime)
    );
    this.observationEditEventStartTimeField.val(
      this.player.gamevideojs.returnFormattedDataMatch(this.currentStartTime)
    );
    this.observationEditEventEndTimeField.val(
      this.player.gamevideojs.returnFormattedDataMatch(this.currentEndTime)
    );

    // Update camera angle links
    this.updateCameraAngleLinks();
  }

  updateCameraAngleLinks() {
    let scope = this;

    this.cameraAngleLinks.each(function () {
      let href = $(this).attr("href");

      let url = new Url(href);
      url.query.event_start_time = scope.player.currentTime();

      $(this).attr("href", url.toString());
    });
  }

  calcMinutesAndSeconds(currentTime) {
    if (currentTime > 0) {
      let minutes = Math.floor(currentTime / 60);
      let seconds = Math.floor(currentTime - minutes * 60);

      return [minutes, seconds];
    } else {
      return [0, 0];
    }
  }

  formatHourMinute(minutes, seconds) {
    let x = minutes < 10 ? "0" + minutes : minutes;
    let y = seconds < 10 ? "0" + seconds : seconds;

    return x + ":" + y;
  }

  updateVideoCrop() {
    if (this.player && this.player.offset) {
      this.player.offset({
        start: this.currentStartTime,
        end: this.currentEndTime
      });
    }
  }
}
